<template>
  <div class="vx-card" id="create-remittance">
    <div class="vx-card__body">
      <form>
        <div class="vx-row">
          <div class="vx-col lg:w-1/4 sm:w-1/2 w-full my-2">
            <label class="vs-select--label">{{ $t("CategoryName") }}</label>
            <v-select
              class="m-0"
              label="name"
              name="categoryName"
              :options="allDepartment"
              v-model="departmentUnitName"
              v-validate="{ required: true }"
              dir="rtl"
            >
            </v-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('categoryName')"
              >{{ errors.first("categoryName") }}</span
            >
          </div>

          <div class="vx-col lg:w-1/4 sm:w-1/2 w-full mt-1">
            <label class="vs-select--label datepicker-lb">{{
              $t("DeliveryDate")
            }}</label>
            <date-picker
              v-model="deliveryClock"
              type="datetime"
              format="jYYYY-jMM-jDD HH:mm:ss"
              v-validate="'required'"
              display-format="jYYYY-jMM-jDD HH:mm:ss"
              id="date-picker"
              :label="$t('DeliveryDate')"
              name="date"
            />
            <span class="text-danger text-sm" v-show="errors.has('date')">{{
              errors.first("date")
            }}</span>
          </div>
          <div class="vx-col lg:w-2/4 sm:w-1/2 w-full my-2">
            <vs-textarea
              :placeholder="$t('Description')"
              v-model="description"
              name="Description"
              :label="$t('Description')"
            />
          </div>
        </div>

        <div class="flex justify-end">
          <vs-button type="filled" @click.prevent="add">
            <span v-if="productSection">{{ $t("Edit") }}</span>
            <span v-else> {{ $t("Continue") }}</span>
          </vs-button>
        </div>
      </form>
      <form v-if="productSection">
        <div class="vx-row">
          <div class="vx-col lg:w-1/4 sm:w-1/2 w-full my-2">
            <vs-input
              v-model="productName"
              name="productName"
              v-validate="'required'"
              :label="$t('ProductName')"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('productName')"
              >{{ errors.first("productName") }}</span
            >
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/2 w-full my-2">
            <vs-input
              v-model="modelNumber"
              name="modelNumber"
              v-validate="'required'"
              :label="$t('ModelNumber')"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('modelNumber')"
              >{{ errors.first("modelNumber") }}</span
            >
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/2 w-full my-2">
            <label class="vs-select--label">{{ $t("Unit") }}</label>
            <v-select
              class="m-0"
              label="name"
              name="unit"
              :options="allUnits"
              v-model="unit"
              v-validate="'required'"
              dir="rtl"
            >
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('unit')">{{
              errors.first("unit")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/2 w-full my-2">
            <vs-input
              v-model="amount"
              name="amount"
              v-validate="'required'"
              :label="$t('Amounts')"
            />
            <span class="text-danger text-sm" v-show="errors.has('amount')">{{
              errors.first("amount")
            }}</span>
          </div>
        </div>
        <div class="mt-5 w-full flex items-end mb-2 justify-end">
          <vs-button
            type="filled"
            :disabled="
              !amount ||
              !departmentUnitName ||
              !deliveryClock ||
              !productName ||
              !modelNumber
            "
            @click.prevent="addProduct"
            >{{ $t("Add") }}</vs-button
          >
        </div>
      </form>
    </div>
    <div v-if="pharchaseRequestItems" class="vx-row mx-3">
      <div class="vx-col w-full mb-base">
        <vs-table :data="productList" class="custom-tbl">
          <template slot="thead">
            <th style="width: 5%">#</th>
            <th style="width: 30%">{{ $t("ProductName") }}</th>
            <th style="width: 20%">{{ $t("ModelNumber") }}</th>
            <th style="width: 10%">{{ $t("Unit") }}</th>
            <th style="width: 10%">{{ $t("Amounts") }}</th>
            <th style="width: 30%">{{ $t("Action") }}</th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="i" v-for="(product, i) in data">
              <vs-td>
                {{ i + 1 }}
              </vs-td>
              <vs-td>
                {{ product.productName }}
              </vs-td>
              <vs-td>
                {{ product.modelNumber }}
              </vs-td>
              <vs-td>
                {{ product.unitOfMeasures.name }}
              </vs-td>
              <vs-td>
                {{ product.count }}
              </vs-td>
              <vs-td>
                <div class="flex items-center gap-3 justify-center">
                  <vs-button
                    radius
                    color="danger"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-x"
                    @click.prevent="deletePurchaseRequestItem(i)"
                    class="d-inline remove-btn flex-shrink-0"
                  ></vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div class="mt-5 w-full flex items-end mb-2 justify-end">
          <vs-button type="filled" @click.prevent="submitForm">{{
            $t("Save")
          }}</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "vue-select";
import { mapActions } from "vuex";
import { mapGetters } from "vuex/dist/vuex.common.js";
import { Validator } from "vee-validate";

const dict = {
  custom: {
    amount: {
      required: "لطفا مقدار کالا را وارد نمایید.",
    },
    categoryName: {
      required: "لطفا نام دپارتمان را وارد نمایید.",
    },
    date: {
      required: "لطفا تاریخ تحویل را وارد نمایید.",
    },
    productName: {
      required: "لطفا نام محصول را وارد نمایید.",
    },
    modelNumber: {
      required: "لطفا مدل نامبر را وارد نمایید.",
    },
    unit: {
      required: "لطفا واحد اندازه گیری را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  components: {
    "v-select": vSelect,
    DataGrid,
  },
  data() {
    return {
      allDepartment: [],
      allUnits: [],
      productList: [],
      productSection: false,
      pharchaseRequestItems: false,
      model: {},
      productModel: {},
      productName: "",
      modelNumber: "",
      deliveryClock: "",
      description: "",
      unit: {},
      departmentUnitName: {},
      amount: null,

      gridDataSource: {
        type: "app",
        service: "Credits/api/DetailAccountsQuery",
      },
      gridSearchData: {
        keyword: "",
      },
    };
  },

  mounted() {
    this.fetchUnits().then((r) => {
      this.allUnits = r;
    });
    this.fetchDepartment().then((r) => {
      this.allDepartment = r;
    });
  },
  methods: {
    ...mapActions({
      addPurchaseRequest: "purchaseRequest/createPurchaseRequest",
      fetchUnits: "unit/fetchList",
      fetchDepartment: "departman/departmanList",
    }),
    addProduct() {
      this.$validator.validateAll().then((result) => {
        const product = {
          productName: this.productName,
          modelNumber: this.modelNumber,
          unitOfMeasures: this.unit,
          unitOfMeasureId: this.unit.id,
          count: this.amount,
        };
        this.productList.push(product);
        (this.productName = ""),
          (this.modelNumber = ""),
          (this.unit = {}),
          (this.amount = 0),
          (this.pharchaseRequestItems = true);
      });
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (this.productList)
          this.model = {
            departmentId: this.departmentUnitName.id,
            deliveryClock: this.deliveryClock,
            description: this.description,
            purchaseItems: this.productList,
          };

        this.addPurchaseRequest(this.model)
          .then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "درخواست خرید مورد نظر ایجاد شد",
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              this.productList = [];
              this.$router.go(-1);
            });
          })
          .catch((e) => {
            this.productList = [];
          });
      });
    },
    add() {
      this.productSection = true;
    },
    deletePurchaseRequestItem(index) {
      this.$swal({
        position: "center-center",
        text: "آیا از حذف این آیتم اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then(() => {
        this.productList.splice(index, 1);
      });
    },
  },
};
</script>
